import { TabsContext } from "components/EvtKit/tabs/Tabs"
import React, { ReactNode, memo, useCallback, useContext, useEffect } from "react"

interface TabsListProps {
  children: ReactNode
}

const TabsList = (props: TabsListProps) => {
  const { children } = props

  const { setTabsIdList } = useContext(TabsContext)

  const setTriggerIdsList = useCallback(() => {
    const childrenArray = React.Children.toArray(children)

    const triggerIds = childrenArray.map((child) => {
      if (!React.isValidElement(child)) {
        return
      }

      return child.props.triggerId
    })

    setTabsIdList(triggerIds)
  }, [children, setTabsIdList])

  useEffect(() => {
    setTriggerIdsList()
  }, [])

  return <>{children}</>
}

export default memo(TabsList)
